/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import './shadow-card.less';

export const ShadowCard = ({ className, children, onClick }) => {
    const classes = classNames('shadow-card', className);
    function handleClick() {
        onClick && onClick();
    }
    return (
        <div className={classes} onClick={handleClick}>
            <div className="shadow-card-inner inner">{children}</div>
        </div>
    );
};
